import React, { useEffect } from "react";
import { HashLink } from "react-router-hash-link";

import SubscriptionList from "../components/app_components/SubscriptionList";

import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";

const AnalysisPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page
  }, []);
  const data = [
    { name: "Netflix", value: 12.99, color: "#1e40af" },
    { name: "Disney+", value: 5.99, color: "#3b82f6" },
    { name: "Canva Pro", value: 14.99, color: "#60a5fa" },
    { name: "Spotify", value: 10.99, color: "#93c5fd" },
    { name: "Prime Video", value: 2.99, color: "#bfdbfe" },
    { name: "HBO Max", value: 15.99, color: "#2563eb" },
    { name: "LinkedIn", value: 39.99, color: "#3b82f6" },
    { name: "Notion Pro", value: 4.99, color: "#60a5fa" },
    { name: "Apple iCloud", value: 2.99, color: "#93c5fd" },
  ];

  const subscriptions = [
    {
      name: "Netflix",
      price: 12.99,
      daysLeft: 5,
      logo: "https://upload.wikimedia.org/wikipedia/commons/0/08/Netflix_2015_logo.svg",
      nextPayment: "12 December",
      currentPlan: "Standard Plan 12,99€/month",
      start: "November 2021",
    },
    {
      name: "Disney+",
      price: 5.99,
      daysLeft: 14,
      logo: "https://upload.wikimedia.org/wikipedia/commons/3/3e/Disney%2B_logo.svg",
      nextPayment: "20 December",
      currentPlan: "Basic Plan 5,99€/month",
      start: "July 2022",
    },
    {
      name: "Canva Pro",
      price: 14.99,
      daysLeft: 22,
      logo: "https://upload.wikimedia.org/wikipedia/commons/5/5e/Canva_logo..png",
      nextPayment: "28 December",
      currentPlan: "Pro Plan 14,99€/month",
      start: "January 2021",
    },
    {
      name: "Spotify",
      price: 10.99,
      daysLeft: 25,
      logo: "https://upload.wikimedia.org/wikipedia/commons/2/26/Spotify_logo_with_text.svg",
      nextPayment: "1 January",
      currentPlan: "Premium Plan 10,99€/month",
      start: "March 2020",
    },
    {
      name: "HBO Max",
      price: 15.99,
      daysLeft: 3,
      logo: "https://upload.wikimedia.org/wikipedia/commons/1/17/HBO_Max_Logo.svg",
      nextPayment: "10 December",
      currentPlan: "Ad-Free Plan 15,99€/month",
      start: "June 2022",
    },
    {
      name: "LinkedIn",
      price: 39.99,
      daysLeft: 18,
      logo: "https://upload.wikimedia.org/wikipedia/commons/c/c9/Linkedin.svg",
      nextPayment: "25 December",
      currentPlan: "Career Plan 39,99€/month",
      start: "February 2023",
    },
    {
      name: "Notion Pro",
      price: 4.99,
      daysLeft: 7,
      logo: "https://upload.wikimedia.org/wikipedia/commons/e/e9/Notion-logo.svg",
      nextPayment: "15 December",
      currentPlan: "Personal Pro 4,99€/month",
      start: "January 2022",
    },
    {
      name: "Apple iCloud",
      price: 2.99,
      daysLeft: 20,
      logo: "https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg",
      nextPayment: "27 December",
      currentPlan: "50GB Plan 2,99€/month",
      start: "May 2021",
    },
  ];

  const total = subscriptions.reduce((sum, item) => sum + item.price, 0);

  return (
    <div className="p-4">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <HashLink className="text-blue-500 text-sm" to="/demo">
          Back
        </HashLink>

        <h1 className="text-lg font-bold text-blue-500">Analysis</h1>
        <button className="text-blue-500 text-sm">?</button>
      </div>

      {/* Donut Chart */}
      <div className="flex justify-center items-center mb-6">
        <ResponsiveContainer width="100%" height={250}>
          <PieChart>
            <Pie
              data={data}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={80}
              fill="#8884d8"
              paddingAngle={8}
              isAnimationActive={true}
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
        <div className="absolute z-[-1]">
          <h2 className="text-blue-500 font-bold text-2xl">
            {total.toFixed(2)}€
          </h2>
          <p className="text-gray-500 text-sm">/mo</p>
        </div>
      </div>

      <SubscriptionList subscriptions={subscriptions} />
    </div>
  );
};

export default AnalysisPage;
